import { ApiObjectiveSlapResponse, StickerDesignId, SlapId, Board, FocusedPlace } from '../utils/Primitives'
import AddressDisplay from '../components/AddressDisplay'
import { getUrlForCID } from '../stickers/StickerDesigns';
import { getObjective } from '../objectives/Objectives';
import React from 'react';
import { displayDateForUI } from '../utils/GeneralUtilities';
interface SlapRowShallowProps {
    objectiveSlap: ApiObjectiveSlapResponse;
    boardRef: React.MutableRefObject<Board>
    handleStickerClick: (stickerId: StickerDesignId,e: React.MouseEvent<HTMLDivElement>) => void;
    handleSlapClick: (slapId: SlapId, e: React.MouseEvent<HTMLDivElement>) => void;
    setFocusOnPlace: (focusedPlace: FocusedPlace) => void;
}

export default function SlapRowShallow({ objectiveSlap, boardRef, handleStickerClick, handleSlapClick, setFocusOnPlace }: SlapRowShallowProps) {
    return (
        <div
            className="mt-1 flex w-full flex-col items-start gap-3 cursor-pointer transform transition-transform hover:scale-105 rounded text-gray-600 hover:text-gray-950"
            onClick={(e) => {
                handleSlapClick(Number(objectiveSlap.slapId), e);
                setFocusOnPlace({ placeId: Number(objectiveSlap.placeId), source: 'sidebar' });
            }}
        >
            <div className="flex w-full items-start gap-3">
                <div className="relative w-14 h-14">
                    {objectiveSlap.stickerDesignId && (
                        <img
                            src={getUrlForCID(objectiveSlap.imageCID)}
                            alt={objectiveSlap.name || 'Sticker'}
                            className="object-contain rounded w-full h-full"
                        />
                    )}
                </div>
                <div className="flex flex-col h-14 justify-center">
                    <div className="text-xs text-gray-600 font-bold">
                        #{objectiveSlap.slapId}
                    </div>
                    <div className="text-xs">
                        <AddressDisplay 
                            address={objectiveSlap.playerAddress} 
                            ensName={objectiveSlap.playerEns} 
                        />
                    </div>
                    {objectiveSlap.slappedAt && (
                        <div className="text-xs">
                            {displayDateForUI(
                                new Date(objectiveSlap.slappedAt)
                            )}
                        </div>
                    )}
                    <div className="text-xs">
                        {objectiveSlap.objectiveIds?.length > 0 && (
                            <span className="">
                            {objectiveSlap.objectiveIds?.map(
                                objectiveId => {
                                const objective = getObjective({ 
                                    boardRef, 
                                    objectiveId: Number(objectiveId) 
                                })
                                return objective?.name || 
                                    `#${objectiveId}`
                            }).join(', ')}
                            </span>
                        )}
                        <span className="text-gray-500">&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
